import React from 'react';
import '../Layout.css';

export default function DarkModeToggle({ darkMode, onToggle }) {
  return (
    <div
      className={`dark-mode-toggle ${darkMode ? 'active' : ''}`}
      onClick={onToggle}
      title={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      <span className="material-symbols-rounded">{darkMode ? 'dark_mode' : 'light_mode'}</span>
      <div className="dark-mode-switch-track">
        <div className="dark-mode-switch-knob" />
      </div>
    </div>
  );
}
